export default __webpack_public_path__ + "static/media/Minicard_8d.82ad666f.svg";